import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
`;

const Wrapper = styled.section`
  display: grid;
  gap: 1rem;
  width: min(1280px, calc(100% - 1.5rem));
  margin: 0 auto;
`;

const Title = styled.div`
  width: min(240px, 40vw);
  height: 24px;
  border-radius: ${({ theme }) => theme.radii.pill};
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.18), rgba(255, 255, 255, 0.08));
  background-size: 200% 100%;
  animation: ${shimmer} 1.4s linear infinite;
`;

const Grid = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(180px, 18vw);
  gap: 1rem;
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-auto-columns: minmax(160px, 42vw);
  }
`;

const Card = styled.div`
  aspect-ratio: 2 / 3;
  border-radius: ${({ theme }) => theme.radii.md};
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0.08));
  background-size: 200% 100%;
  animation: ${shimmer} 1.4s linear infinite;
`;

function SkeletonRow() {
  return (
    <Wrapper aria-hidden>
      <Title />
      <Grid>
        {Array.from({ length: 6 }).map((_, index) => (
          <Card key={index} />
        ))}
      </Grid>
    </Wrapper>
  );
}

export default SkeletonRow;
